var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9841 0H16.8789L22.6726 8.01857L25.9841 0Z",
    fill: "#FAFF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67285 0L9.98433 8.01857L15.778 0H6.67285Z",
    fill: "#FAFF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3281 3.04785L11.9238 9.14285H20.7324L16.3281 3.04785Z",
    fill: "#FAFF00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8176 1.36133L24.6045 9.14276H32.2941L27.8176 1.36133Z",
    fill: "#FAFF00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83932 1.36157L0.293945 9.143H8.05239L4.83932 1.36157Z",
    fill: "#FAFF00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80577 11.4285H0.363281L15.6957 31.9999H15.7322L8.80577 11.4285Z",
    fill: "#FAFF00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8513 11.4285L16.9248 31.9999H16.9613L32.2937 11.4285H23.8513Z",
    fill: "#FAFF00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3783 11.4285H11.2773L16.3278 26.2856L21.3783 11.4285Z",
    fill: "#FAFF00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.b75318a1ad04ecd5dce9d328db89c6bf.svg";
export { ForwardRef as ReactComponent };